module.exports = function () {
    $(document).ready(function () {

        $(document).on('click', '.vacant-rooms-assign-btn', function() {

            console.log($(this).data('property-id') );
            console.log($(this).data('room-id') );

            $('#modal-property-id-field').val( $(this).data('property-id') );
            $('#modal-room-id-field').val( $(this).data('room-id') );

        });

    });
}();